import { render, staticRenderFns } from "./FlipSellingInfoForm.vue?vue&type=template&id=a54f9f90&scoped=true&"
import script from "./FlipSellingInfoForm.vue?vue&type=script&lang=js&"
export * from "./FlipSellingInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54f9f90",
  null
  
)

export default component.exports